import {Component, NgZone, OnInit} from "@angular/core";
import {MatDialogRef} from "@angular/material/dialog";
import {Subscription} from "rxjs";
import {AddHomescreenService} from "src/app/pwa/add-homescreen.service";
import {TranslateModule} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";


@Component({
    selector: "app-install-banner",
    templateUrl: "./app-install-banner.component.html",
    styleUrls: ["./app-install-banner.component.css"],
    imports: [
    MatIcon,
    TranslateModule
]
})
export class AppInstallBannerComponent implements OnInit {
  promptType: PromptType;
  timeoutRef: any;
  type = PromptType;
  deferredPrompt: any;
  installPromptSub: Subscription;

  constructor(
    private dialogRef: MatDialogRef<AppInstallBannerComponent>,
    private ngZone: NgZone,
    private addHomescreenService: AddHomescreenService,
  ) {
  }


  ngOnInit(): void {
    this.setBrowserSpecificPrompt();
    this.setModalContent();
    this.ngZone.runOutsideAngular(() => {
      this.timeoutRef = setTimeout(() => {
        this.ngZone.run(() => {
          this.dialogRef.close();
        });
      }, 8000);
    });
  }

  setBrowserSpecificPrompt() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (
      /fban/.test(userAgent) ||
      /fbios/.test(userAgent) ||
      /fb_iab/.test(userAgent)
    ) {
      this.promptType = this.type.FACEBOOK;
    } else if (/android/.test(userAgent) && /samsungbrowser/.test(userAgent)) {
      this.promptType = this.type.SAMSUNG;
    } else if (/mobile/.test(userAgent) && /firefox/.test(userAgent)) {
      this.promptType = this.type.FIREFOX;
    } else if (/android/.test(userAgent) && /edg/.test(userAgent)) {
      this.promptType = this.type.EDGE;
    } else if (/android/.test(userAgent) && /chrome/.test(userAgent)) {
      this.promptType = this.type.CHROME;
    } else if (/crios/.test(userAgent)) {
      this.promptType = this.type.CHRIOS;
    } else if (
      /iphone|ipad|ipod|mac os/.test(userAgent) &&
      /safari/.test(userAgent)
    ) {
      this.promptType = this.type.SAFARI;
    } else {
      this.promptType = this.type.NOTSUPPORTED;
    }
  }

  setModalContent() {
    this.deferredPrompt = this.addHomescreenService.getPrompt();
    this.installPromptSub = this.addHomescreenService
      .getInstallPromptChange()
      .subscribe((val) => {
        if (val !== null) {
          this.deferredPrompt = val;
          this.promptType = this.type.INSTALL;
        }
      });
  }

  onInstall() {
    this.deferredPrompt.prompt();
  }

  onClose() {
    this.dialogRef.close();
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
    }
  }
}


export enum PromptType {
  INSTALL = "Install",
  SAMSUNG = "SamsungBrowser",
  CHROME = "ChromeAndroid",
  CHRIOS = "ChromeIos",
  SAFARI = "Safari",
  FIREFOX = "FirefoxMobile",
  EDGE = "EdgeMobile",
  NOTSUPPORTED = "NotSupported",
  FACEBOOK = "Facebook"
}
